import { render, staticRenderFns } from "./TileDataUKCountryPrognose.vue?vue&type=template&id=5675929a"
import script from "./TileDataUKCountryPrognose.vue?vue&type=script&lang=js"
export * from "./TileDataUKCountryPrognose.vue?vue&type=script&lang=js"
import style0 from "./TileDataUKCountryPrognose.vue?vue&type=style&index=0&id=5675929a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports